import '@sass/common/theme.scss';
import CwLoadModules from '@customjs/module-loader.js';
import CwThemeFramework from '@customjs/generalFns.js';
import { MatchHeight } from 'js-match-height';

/**
 * Running mixed functions across the theme
 */
CwThemeFramework.generalFns();
CwThemeFramework.showContent();
/**
 * Bootstrap Tabs
 */
const tabs = document.querySelector('[role="tablist"]');

if (tabs) CwLoadModules.Tabs();

/**
 * Dropdown
 */
const dropdown = document.querySelector('.dropdown-toggle');

if (dropdown) CwLoadModules.Dropdown();

/**
 * Accordions
 */
const accordion = document.querySelector('.accordion');

if (accordion) CwLoadModules.Collapse();

/**
 * Service Worker
 */

// check if service worker is available

if ('serviceWorkerNO' in navigator) {
    document.addEventListener('DOMContentLoaded', () => {
        // Registering Service Worker
        navigator.serviceWorker
            // eslint-disable-next-line no-undef
            .register(`${ThemeURLS.childThemeURL}/sw.php`, {
                scope: '/',
            })
            .then((reg) => console.log(reg.scope))
            .catch((error) => console.log(error.message));
    });
}

/**
 * Loading Mobile Menu
 */

function matchMobile() {
    const mobileMediaQuery = window.matchMedia('(max-width: 1200px)');
    return mobileMediaQuery.matches;
}

matchMobile() ? CwThemeFramework.mobileMenu() : '';

window.addEventListener('resize', () => {
    matchMobile() ? CwThemeFramework.mobileMenu() : '';
});

/**
 * Loading Modals in the Page
 * We will be pulling all the buttons with the data-cw-target
 * Attribute in order to initialize all the modals.
 */

// Checking for all out buttons
const modals = document.querySelectorAll('[data-cw-target]');
if (modals.length) {
    const modalInstances = [];
    CwLoadModules.modals().then((CwModals) => {
        modals.forEach((modalBtn, index) => {
            modalInstances[index] = new CwModals('.cw-modal');
            modalInstances[index].init();
        });
    });
}

/**
 * Loading Swiper JS
 * https://swiperjs.com/
 */
const carouselModules = {
    'results-slider': 'results-carousel',
    'results-slider__sidebar': 'results-slider-sidebar',
    'services-wrap': 'services-carousel',
    'news-wrap': 'news-carousel',
    'awards-wrap': 'awards-carousel',
    'awards-wrap-sidebar': 'awards-carousel-sidebar',
    'testimonials-section-slider': 'testimonials-carousel',
    'testimonials-section-slider-sidebar': 'testimonials-carousel-sidebar',
    'att-section-slider': 'team-carousel',
    'team-section-slider': 'atorney-carousel',
    'grid-videos': 'videos-carousel',
    'our-team': 'team-sidebar-widget',
    'videos-section-slider': 'videos-slider',
};

// eslint-disable-next-line no-restricted-syntax
for (const [key, value] of Object.entries(carouselModules)) {
    const name = document.getElementById(key);
    if (name) {
        CwLoadModules.swiperSliders(value).then((module) => {
            module.default();
        });
    }
}

/**
 * Loading MatchHeight
 * Create new instance of MatchHeight [new MatchHeight()]
 * for elements that need to have the same height
 * https://www.npmjs.com/package/js-match-height
 */

const testimonialItem = new MatchHeight('.testimonials-section__item');
const whychooseusItem = new MatchHeight('.why-choose-us__item');

/**
 * Smooth Scroll
 * add class '.scroll' to new elements
 * class '.scroll' already added to footer back to top and TOC dynamic link elements
 */
const getHeaderScrollOffset = () => {
    const offset = parseInt(
        getComputedStyle(document.documentElement).getPropertyValue(
            '--header-scroll-offset'
        ),
        10
    );

    return Number.isNaN(offset) ? 0 : offset;
};

const scrollToHashTarget = (hash, shouldUpdateHistory = true) => {
    if (!hash || hash === '#') return;

    const target = document.querySelector(hash);
    if (!target) return;

    const top =
        target.getBoundingClientRect().top +
        window.pageYOffset -
        getHeaderScrollOffset();

    window.scrollTo({
        top,
        behavior: 'smooth',
    });

    if (shouldUpdateHistory) {
        history.pushState(null, null, hash);
    }
};

window.addEventListener('load', () => {
    if (window.location.hash) {
        scrollToHashTarget(window.location.hash, false);
    }
});

/**
 * Testimonial Archive Filter
 */
const testimonialFilterEl = document.querySelector('[data-testimonial-filter]');
if (testimonialFilterEl) {
    import(
        /* webpackChunkName: 'testimonial-filter' */
        '@modules/testimonial-filter.js'
    ).then((module) => module.default());
}

/**
 * Video Library (search, filter, pagination)
 */
const videoLibraryEl = document.querySelector('[data-video-grid]');
if (videoLibraryEl) {
    import(
        /* webpackChunkName: 'video-library-module' */
        '@modules/video-library-grid.js'
    ).then((module) => module.default());
}

/**
 * Load More
 */
const loadMore = null || document.querySelector('.load-more');
const categoryFilter = null || document.querySelector('.cw-filter');

if (loadMore || categoryFilter) {
    const enablePagination = loadMore.dataset.pagination;

    CwLoadModules.AjaxCalls().then((cwAjaxLib) => {
        const ajaxCalls = new cwAjaxLib({
            enablePagination: enablePagination,
        });
        ajaxCalls.init();
        if (categoryFilter) ajaxCalls.filter(categoryFilter);
    });
}